import { COLOR_NAMES } from './logging';

// A console handle for the things that have no UI yet. The socket lives in
// React context (`useSocket`), which the browser console cannot reach, so
// without this there is no way to poke the server by hand.
//
// Gated on the same flag as verbose logging — REACT_APP_DEBUG_LOGGING is baked
// in at build time, true under the dev compose overlay and false in prod — so a
// production bundle carries no `window` handle at all.
const ENABLED = process.env.REACT_APP_DEBUG_LOGGING === 'true';

const SOLUTION_TIMEOUT_MS = 30000;

function requestSolution(socket) {
  return new Promise((resolve, reject) => {
    const onSolution = (payload) => {
      clearTimeout(timer); // eslint-disable-line no-use-before-define
      socket.off('SOLVER_SOLUTION', onSolution);
      if (payload && payload.error) {
        reject(new Error(payload.error));
        return;
      }
      const rows = payload.moves.map((move, i) => ({
        '#': i + 1,
        robot: COLOR_NAMES[move.color] || move.color,
        direction: move.direction,
      }));
      // eslint-disable-next-line no-console
      console.table(rows);
      // eslint-disable-next-line no-console
      console.log(`optimal: ${payload.length} moves — ${payload.visitedStates} states in ${payload.elapsedMs}ms`);
      resolve(payload);
    };

    const timer = setTimeout(() => {
      socket.off('SOLVER_SOLUTION', onSolution);
      reject(new Error(`no SOLVER_SOLUTION within ${SOLUTION_TIMEOUT_MS}ms`));
    }, SOLUTION_TIMEOUT_MS);

    socket.on('SOLVER_SOLUTION', onSolution);
    socket.emit('REQUEST_SOLUTION');
  });
}

/**
 * Publish `window.robotrons` for the console. Returns a cleanup function, so it
 * drops straight into a `useEffect`.
 */
export function installDebugHandle(socket) {
  if (!ENABLED || typeof window === 'undefined' || !socket) return () => {};

  window.robotrons = {
    socket,
    // Ask the solver for the optimal solution to the active mission.
    // Host-only, and the server says so rather than staying quiet.
    solution: () => requestSolution(socket),
  };

  // eslint-disable-next-line no-console
  console.log('%c[robotrons] console handle ready — try: await robotrons.solution()',
    'color:#2f9e6e;font-weight:bold');

  return () => {
    if (window.robotrons && window.robotrons.socket === socket) delete window.robotrons;
  };
}

export default installDebugHandle;
